import React from 'react'

const DateInput = React.forwardRef((props, ref) => (
  <div className='date-input'>
    <input
      placeholder='DD.MM.YYYY'
      ref={ref}
      value={props.value}
      onClick={props.onClick} 
      onChange={props.onChange}
      readOnly={true}
    />
    <i className='fa fa-calendar-check-o'></i>
  </div>
))

export default DateInput
